<div class="title" >
  <span class="title estricta uppercase"> Gestão de carteira </span>
</div>

<app-card class="density-lower">

  <form [formGroup]="form" class="density-mat-form-3" (keydown.enter)="$event.preventDefault(); filter()">
    <span class="estricta uppercase"> Filtros </span>
    <br />
    <br />

    <div class="filters">
      <div class="group1">

        <span class="form-field">
          <app-custom-autocomplete formControlName="actives"
                                   label="Dados cadastrais:"
                                   displayKey="key"
                                   valueKey="value"
                                   [list]="activesOptions"
                                   datacy="actives">
          </app-custom-autocomplete>
        </span>

        </div>

        <div class="group1">


          <span class="form-field">
            <label> Ponto de Venda: </label>
            <mat-form-field appearance="outline" class="density-mat-form-3">
              <mat-select formControlName="identifierCode" data-cy="identifierCode" placeholder="Selecione">
                <mat-option *ngFor="let dealerOption of dealerOptions" [value]="dealerOption.value"> {{dealerOption.key}}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="form.get('identifierCode').hasError('required')">
                <strong> Campo obrigatório </strong>
              </mat-error>
            </mat-form-field>
          </span>

        </div>

    </div>


    <div class="filters">


      <div class="group1">
        <app-custom-datapicker label="Data Inicial:"
                               formControlName="initialDate"
                               [control]="form.get('initialDate')"
                               datacy="initialDate">
          <mat-error *ngIf="form.hasError('startGreaterThanEnd') && form.get('initialDate').touched && form.get('endDate').touched" data-cy="initialDateErrorStartGreaterThanEnd" class="translate-y">
            <strong> Data Inicial não pode ser maior que data final </strong>
          </mat-error>
          <mat-error *ngIf="form.hasError('initialDate-required')" data-cy="initialDateErrorStartDateAndEndDateMustBeFilled" class="translate-y">
            <strong> Data Inicial deve ser prenchida </strong>
          </mat-error>
          <mat-error *ngIf="form.hasError('periodGreaterThanDays')" data-cy="initialDateErrorPeriodGreaterThanDays" class="translate-y">
            <strong> Não é possível efetuar pesquisa com mais de 30 dias </strong>
          </mat-error>
        </app-custom-datapicker>


      </div>

      <div class="group1">

        <app-custom-datapicker label="Data Final:" formControlName="endDate" [control]="form.get('endDate')"
          datacy="endDate">
          <mat-error *ngIf="form.hasError('endDate-required')" data-cy="endDateDateErrorStartDateAndEndDateMustBeFilled" class="translate-y">
            <strong> Data Final deve ser prenchida </strong>
          </mat-error>
        </app-custom-datapicker>


      </div>
    </div>

    <div class="button-filters">
      <app-button type="submit" width="100%" datacy="button-clean" (onClick)="cleanForm()" [disabled]="!hasAccessToAnyDealer">
        <span style="font-size: 16px;"> Limpar </span>
      </app-button>

      <app-button type="submit" width="100%" color="primary" [disabled]="!form.valid || loading || !hasPermissionToRead || !hasAccessToAnyDealer" [loading]="loading"
        (onClick)="filter()" datacy="button-search">
        <span style="font-size: 16px;"> Pesquisar </span>
      </app-button>
    </div>
  </form>

</app-card>

<div class="table">
  <app-table [table]="table"
             (emitPaginatorChanged)="pageChange($event)"
             (emitActionView)="openDetails($event)">
  </app-table>
</div>